(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products-section"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(complementaryProductsSection);
    const url = complementaryProductsSection.dataset.url;
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.complementary-products-container');
        if (recommendations && recommendations.innerHTML.trim().length) {
          complementaryProductsSection.querySelector('.complementary-products-container').innerHTML = recommendations.innerHTML;
          complementaryProductsSection.classList.add('pb-50');
        } else {
          complementaryProductsSection.style.display = 'none';
        }
      })
      .catch(e => {
        console.error(e);
        complementaryProductsSection.style.display = 'none';
      });
  };
  const complementaryProductsSection = document.querySelector('.complementary-products');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  observer.observe(complementaryProductsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complementary-products"] && !Shopify.designMode) return;
  try {
    
  const handleComplementaryProductsIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(complementaryProductsSection);
    const url = complementaryProductsSection.dataset.url;
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.complementary-products-section');
        if (recommendations && recommendations.innerHTML.trim().length) {
          complementaryProductsSection.innerHTML = recommendations.innerHTML;
        } else {
          complementaryProductsSection.style.display = 'none';
        }
      })
      .catch(e => {
        console.error(e);
        complementaryProductsSection.style.display = 'none';
      });
  };
  const complementaryProductsSection = document.querySelector('.complementary-products-section');
  if (complementaryProductsSection) {
    const observer = new IntersectionObserver(handleComplementaryProductsIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(complementaryProductsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
